﻿import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import * as React from 'react'
import * as Sentry from "@sentry/react";

// Initialize Sentry ONCE, outside of any React component
Sentry.init({
    dsn: "https://1940b328ef389fb3261a44ad78d248ab@o4511705014599680.ingest.de.sentry.io/4511705047236688",
    release: import.meta.env.VITE_APP_VERSION,
    environment: window.location.hostname.includes('staging') ? 'staging' : 'production',
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            // Masking is enabled to protect sensitive user input (passwords, emails, etc.)
            // in Sentry session replays. Only unmask fields selectively if they are
            // confirmed non-sensitive and a privacy review has been completed.
            maskAllText: false,
            maskAllInputs: false,
            blockAllMedia: false,
            unblock: [".sentry-unblock", "[data-sentry-unblock]"],
            unmask: [".sentry-unmask", "[data-sentry-unmask]"],

            // Disable compression for self-hosted Sentry compatibility.
            // Sentry SDK v8+ defaults to compressing replay recordings via a dedicated
            // web worker. In a private/self-hosted deployment this worker can silently
            // fail because the default worker URL references sentry.io CDN assets that
            // are unreachable from the private network.  When the worker cannot be
            // loaded the SDK falls back to dropping recordings (Client Discarded) or
            // sending malformed payloads (Invalid Session Replays / Network Error).
            // Disabling compression sends recordings uncompressed — payload sizes are
            // larger, but the data is correctly formatted and Sentry Relay on any
            // version can ingest it without additional configuration.
            useCompression: false,
        })
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
        /^https:\/\/staging\.capland\.co\.za\/api/,
        /^https:\/\/captrac\.capland\.co\.za\/api/
    ],
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0
});

// Optional: Sentry error boundary for better error handling
ReactDOM.createRoot(document.getElementById('root')).render(
        <BrowserRouter>
            <Sentry.ErrorBoundary fallback={<p>An error occurred in the application.</p>}>
                <App />
            </Sentry.ErrorBoundary>
        </BrowserRouter>
);